import angular from 'angular';
import moment from 'moment';
import { PagamentosPontoService } from '../pagamentos.service';
import { ApuracoesPontoService } from '../../ApuracoesPonto/apuracoesponto.service';
import { RubricasPontoService } from '../../../../Apontamentos/rubricasponto.service';
import { ModalConfirmService } from '../../../../../shared/components/modal-confirm/modal.confirm.service';
import { PagamentosPontoConfirmModalService } from '../modals/pagamentos-confirm/pagamentos-confirm.modal.service';
import { IApuracaoFilter, IApuracaoPonto, IApuracaoPontoGetResponse, IApuracaoSelectItem } from '../../models/apuracaoponto.model';
import { applyNsjTableInlineMobileLabels } from '../../../../../utils/nsj-table';
import { IPagamentoConfirmModal, IPagamentoPonto } from '../../models/pagamentoponto.model';

type IPagamentosPontoFilters = {
	apuracao: IApuracaoFilter | null;
	lotacao: { lotacao: string } | null;
	departamento: { departamento: string } | null;
	grupo: { grupo: string } | null;
	trabalhador: { trabalhador: string } | null;
	situacaoColaborador: string | null;
};

type IPagamentoPontoEntity = IPagamentoPonto & {
	codigo?: string;
	disableCheckbox?: boolean;
	rowcustomclass?: string;
};

type IPagamentoPontoDisplayEntity = {
	codigo?: string;
	nome: string;
	trabalhador: string;
	urlponto: string;
	disableCheckbox?: boolean;
	rowcustomclass?: string;
	[key: string]: any;
};

export class PagamentosPontoIndexController {

    static $inject = [
		'$rootScope',
		'$scope',
		'$state',
		'$stateParams',
		'PagamentosPontoService',
		'ApuracoesPontoService',
		'RubricasPontoService',
		'ModalConfirmService',
		'PagamentosPontoConfirmModalService',
		'toaster',
		'NewToaster'
	];

    // initial state
	public displayEntities: IPagamentoPontoDisplayEntity[] = [];
	public entities: any = [];
    public apuracoes: Array<IApuracaoPonto> = [];
    public busy: boolean = false;
	public apuracoesSelect: IApuracaoSelectItem[] = [];
	public filters: IPagamentosPontoFilters = {
		apuracao: null,
		lotacao: null,
		departamento: null,
		grupo: null,
		trabalhador: null,
		situacaoColaborador: '00',
	};
    public filtersParams = {
        empresa: '',
        estabelecimento: ''
    };
	public filterActive: boolean = false;
	public filterApuracoesStatusPagamento: number | null = null;
    public statusPagamentoInterval: NodeJS.Timeout;
	public rubricasponto: Array<any> = [];
	public rubricasLoaded: boolean = false;
	public pagamentosLoaded: boolean = false;
	public fieldsBuilt: boolean = false;

    // table
	public checkboxPreenchidos: Array<IPagamentoPontoDisplayEntity> = [];
	public checkToggle: any = {};
	public fields: Array<any> = [];

    constructor (
		public $rootScope: angular.IRootScopeService & {
			liberadoTela: (arg: string) => boolean,
			temPermissao: (arg: string) => boolean,
			configuracoes: any,
			session: any,
			nsjGlobals: any
		},
		public $scope: angular.IScope,
		public $state: angular.ui.IStateService,
		public $stateParams: angular.ui.IStateParamsService,
		public PagamentosPontoService: PagamentosPontoService,
		public ApuracoesPontoService: ApuracoesPontoService,
		public RubricasPontoService: RubricasPontoService,
		public ModalConfirmService: ModalConfirmService,
		public PagamentosPontoConfirmModalService: PagamentosPontoConfirmModalService,
		public toaster: any,
		public NewToaster: { pop: Function },
	) {
		if (
			!this.$rootScope.temPermissao('visualizar_pagamentos') ||
			!this.$rootScope.liberadoTela('LIBERAR_PAGAMENTOS')
		) {
            $state.go('dp');
        }

        this.busy = true;
		this.carregaRubricas();
		this.carregaApuracoes();

        $scope.$on('apuracoesponto_index_loaded', () => {
			if (this.ApuracoesPontoService.loadParams.finished ||
                this.ApuracoesPontoService.loadParams.to_load === 0
            ) {
                this.filterApuracoesStatusPagamento = null;
                this.montaApuracaoSelect();
            }
        });

        $scope.$on('ponto_apuracoesponto_get_loaded', (event, args: IApuracaoPontoGetResponse) => {
            if (
                args &&
                this.filterApuracoesStatusPagamento !== args.apuracaoprocessamento.statuspagamento
            ) {
                this.apuracoes = this.apuracoes.map(apuracao => {
                    if (apuracao.apuracaoponto === args.apuracaoponto) {
                        apuracao.apuracaoprocessamento.statuspagamento = args.apuracaoprocessamento.statuspagamento;
                    }
                    return apuracao;
                });
		        this.filterApuracoesStatusPagamento = args.apuracaoprocessamento.statuspagamento;
            }
        });

        $scope.$on('pagamentoslancamentos_relatoriopagamento_loaded', (event, args: any) => {
            this.entities = args;
			this.pagamentosLoaded = true;
			this.maybeBuildTable();
		});

        $scope.$on('apontamentos_rubricasponto_index_service_list_finished', (event, args: any) => {
			this.rubricasponto = args;
			this.rubricasLoaded = true;
			this.maybeBuildTable();
        });

        $scope.$on('apuracoesponto_liberarpagamentos_iniciado', () => {
            this.carregaApuracoes();
			this.NewToaster.pop({
				type: 'success',
				title: 'Pagamentos liberados com sucesso.',
			});
        });

        $scope.$on('apuracoesponto_liberarpagamentos_erro', () => {
			this.busy = false;
			this.NewToaster.pop({
				type: 'error',
				title: 'Ocorreu um erro ao liberar pagamentos.',
			});
        });

        $scope.$on('apuracoesponto_regerarpagamentos_iniciado', () => {
			this.busy = false;
			this.NewToaster.pop({
				type: 'success',
				title: 'Pagamentos regerados com sucesso.',
			});
        });

        $scope.$on('apuracoesponto_regerarpagamentos_erro', () => {
			this.busy = false;
			this.NewToaster.pop({
				type: 'error',
				title: 'Ocorreu um erro ao regerar pagamentos.',
			});
        });

        $scope.$on('apuracoesponto_regerarpagamentosindividual_iniciado', () => {
			this.busy = false;
			this.NewToaster.pop({
				type: 'success',
				title: 'Pagamentos do colaborador gerados novamente com sucesso.',
			});
        });

        $scope.$on('apuracoesponto_regerarpagamentosindividual_erro', () => {
			this.busy = false;
			this.NewToaster.pop({
				type: 'error',
				title: 'Ocorreu um erro ao gerar pagamentos do colaborador.',
			});
        });

        $scope.$on('pagamentoslancamentos_relatoriopagamentoexportacao_sucesso', (event, args: any) => {
			this.trataDownload(args.data);
			this.busy = false;
        });

        $scope.$on('pagamentoslancamentos_relatoriopagamentoexportacao_erro', () => {
			this.busy = false;
        });

        $scope.$watch('mrh_pgmts_lst_cntrllr.filterApuracoesStatusPagamento',
            (newValue: number | null, oldValue: number | null): void => {
                if (newValue !== oldValue) {
                    if (newValue === 4) {
                        clearInterval(this.statusPagamentoInterval);
                        this.statusPagamentoInterval = setInterval(() => {
                            this.ApuracoesPontoService.get(this.filters.apuracao!.apuracaoponto);
                        }, 60000);
                    } else {
                        clearInterval(this.statusPagamentoInterval);
                    }
                }
        }, true);

        $scope.$on('$destroy', () => {
            clearInterval(this.statusPagamentoInterval);
        });
    }

	carregaApuracoes() {
		this.busy = true;
		this.ApuracoesPontoService.constructors['vigente'] = false;
		this.ApuracoesPontoService.constructors['empresa'] = this.$rootScope.session.entities.empresa.empresa;
		this.ApuracoesPontoService.constructors['estabelecimento'] = '';
		this.apuracoes = this.ApuracoesPontoService.reload();
	}

    carregaRubricas() {
        this.RubricasPontoService.constructors['estabelecimento'] = this.$rootScope.session.entities.estabelecimento.estabelecimento;
        this.RubricasPontoService.constructors['empresa'] = this.$rootScope.session.entities.empresa.empresa;
        this.rubricasponto = this.RubricasPontoService.reload();
    }

	montaDisplayEntities(): void {
		this.displayEntities = [];
		// aguardando campo statuspagamento ser retornado para descomentar as seguintes linhas.
		// let isOdd = 0;
		this.entities.forEach((entity: IPagamentoPontoEntity, indexEntity: number) => {

			// if (this.filterApuracoesStatusPagamento === null || this.filterApuracoesStatusPagamento === 0) {
			// 	if (isOdd == 0) {
			// 		entity['rowcustomclass'] = 'table-yellow-bg';
			// 		isOdd = 1;
			// 	} else {
			// 		entity['rowcustomclass'] = 'table-yellow-bg-darker';
			// 		isOdd = 0;
			// 	}
			// }

			const displayEntity: IPagamentoPontoDisplayEntity = {
				codigo: entity.codigo,
				nome: entity.nome,
				trabalhador: entity.trabalhador,
				urlponto: entity.urlponto,
			};

			if (typeof entity.disableCheckbox !== 'undefined') {
				displayEntity.disableCheckbox = entity.disableCheckbox;
			}

			if (typeof entity.rowcustomclass === 'string') {
				displayEntity.rowcustomclass = entity.rowcustomclass;
			}

			entity.pagamentos.forEach((element: any, index) => {
				let pagamento = angular.copy(element);
				pagamento['index'] = index;
				let pagamentoName = 'pagamento' + pagamento.codigo;

				if (element.valor === 0 || !this.valorExiste(element.valor)) {
					pagamento.lancamento_formato = '';
				}
				if (element.tipo === '5' && element.valor > 0) {
					pagamento.lancamento_formato = element.valor;
				}

				displayEntity[pagamentoName] = angular.copy(pagamento);
			});

			this.displayEntities[indexEntity] = displayEntity;
		});
	}

	montaFieldsTable(): void {
		let fields: Array<any> = [
			{
				value: 'codigo',
				label: 'Matrícula',
				type: 'string',
				style: 'title',
				copy: '',
			},
			{
				value: 'nome',
				label: 'Colaboradores',
				type: 'string',
				style: 'title',
				copy: '',
			},
		];

		this.rubricasponto.forEach((rubrica: any) => {
			fields.push({
				value: `pagamento${rubrica.codigo}.lancamento_formato`,
				label: rubrica.nome,
				type: 'string',
				style: 'title',
				copy: '',
			});
		});

		fields.push({
			value: 'urlponto',
			label: 'Ações',
			type: 'string',
			style: 'title',
			copy: '',
			customCollumnHtml: () => {
				return `
                    <a class="btn btn-sm" href="{{tableRowEntity.urlponto}}" target="_blank">
                        <i
                            class="fa fa-external-link-alt"
                            aria-hidden="true"
                            uib-tooltip="Ponto"
                            tooltip-placement="top"
                        ></i>
                    </a>
                `;
			},
		});
		this.fields = applyNsjTableInlineMobileLabels(angular.copy(fields));
		this.fieldsBuilt = true;
	}

    /* INÍCIO - COMBO DE FUNÇÕES PARA HABILITAR AS FUNÇÕES SELECIONAR TODOS E DOWNLOAD EM LOTE */
	checar_todos(): void {
		this.checkToggle = document.getElementById('check_all') as HTMLInputElement;

		if (this.checkToggle.checked) {
			let checked = this.displayEntities.filter((entity: any): boolean => !entity.disableCheckbox);
			this.checkboxPreenchidos = angular.copy(checked);

			if (checked.length !== this.displayEntities.length) {
				this.toaster.pop({
					type: 'info',
					title: 'Atenção!',
					body: 'toaster-html-directive',
					directiveData: { entities: this.displayEntities },
					bodyOutputType: 'directive',
					timeout: 5000
				});
			}
		} else {
			this.checkboxPreenchidos = [];
		}
	}

	temTodosMarcados(): boolean {
		return !!this.displayEntities.length && (this.checkboxPreenchidos.length === this.displayEntities.length);
	}

	naoTemTodosMarcados(): boolean {
		return !!this.checkboxPreenchidos.length && !this.temTodosMarcados();
	}
	/* FIM - COMBO DE FUNÇÕES PARA HABILITAR AS FUNÇÕES SELECIONAR TODOS E DOWNLOAD EM LOTE */

	getRowCustomClass(entity: IPagamentoPontoDisplayEntity & { rowcustomclass: string} ): string {
		return entity.rowcustomclass;
	}

	montaApuracaoSelect(): void {
		this.apuracoesSelect = this.apuracoes.map((element) => {
			const { nome: nomeReferencia, referencia } = this.getReferenciaApuracao(element);
			return {
				periodo: `
                    ${moment(element.inicioapuracao).format('DD/MM/YYYY')} a
                    ${moment(element.terminoapuracao).format('DD/MM/YYYY')} ${nomeReferencia}`,
				inicioapuracao: element.inicioapuracao,
				terminoapuracao: element.terminoapuracao,
				apuracaoponto: element.apuracaoponto,
                referencia,
				statuspagamento: element.apuracaoprocessamento.statuspagamento,
			};
		});
        const filterApuracao = this.filters.apuracao;
        if (filterApuracao) {
            const updatedFilter = this.apuracoesSelect.find(elem => elem.apuracaoponto === filterApuracao.apuracaoponto);
            if (updatedFilter) {
                this.filters.apuracao = updatedFilter;
                this.filterReload();
                return;
            }
        }
        this.setFilterApuracao();
        this.filterApuracao();
	}

	getReferenciaApuracao(apuracao: IApuracaoPonto) {
		if (apuracao.trabalhadorobj?.trabalhador) {
            return {
                nome: `- Trabalhador: ${apuracao.trabalhadorobj.nome}`,
                referencia: apuracao.trabalhadorobj
            };
        }
        if (apuracao.lotacaoobj?.lotacao) {
            return {
                nome: `- Lotação: ${apuracao.lotacaoobj.nome} `,
                referencia: apuracao.lotacaoobj
            };
        }
        if (apuracao.estabelecimentoobj?.estabelecimento) {
            return {
                nome: `- Estabelecimento: ${apuracao.estabelecimentoobj.nomefantasia}`,
                referencia: apuracao.estabelecimentoobj
            };
        }
        if (apuracao.empresaobj?.empresa) {
            return {
                nome: `- Empresa: ${apuracao.empresaobj.razaosocial}`,
                referencia: apuracao.empresaobj
            };
        }
        return {
            nome: '',
            referencia: null
        };
    }

    setFilterApuracao() {
        if (!this.apuracoesSelect.length) {
            return;
        }

        const hasApuracaoParam = this.valorExiste(this.$stateParams.apuracaoponto);
        if (hasApuracaoParam) {
            const apuracao = this.apuracoesSelect.find(elem => elem.apuracaoponto === this.$stateParams.apuracaoponto);
            this.filters.apuracao = apuracao ?? {
                apuracaoponto: this.$stateParams.apuracaoponto,
                referencia: null
            };
            return;
        }

        const dataAtual = moment();
        const apuracaoAtual = this.apuracoesSelect.find(apuracao => {
            const inicioApuracao = moment(apuracao.inicioapuracao, 'YYYY-MM-DD');
            const terminoApuracao = moment(apuracao.terminoapuracao, 'YYYY-MM-DD');
            return dataAtual.isBetween(inicioApuracao, terminoApuracao, undefined, '[]')
                && apuracao.referencia && ('empresa' in apuracao.referencia);
        });

        if (apuracaoAtual) {
            this.filters.apuracao = apuracaoAtual;
            return;
        }
        this.filters.apuracao = this.apuracoesSelect[0];
    }

    filterApuracao() {
        const apuracao = this.filters.apuracao;
        if (!apuracao) {
            this.busy = false;
            return;
        }

        const filtersToReset = ['grupo', 'lotacao', 'departamento', 'trabalhador'];
        filtersToReset.forEach(key => this.filters[key] = null);

        let empresa = this.$rootScope.session.entities.empresa.empresa;
        let estabelecimento = '';

        const referencia = apuracao.referencia;
        if (!referencia) {
            this.refreshFilters(empresa, estabelecimento);
            this.filterReload();
            return;
        }

        if ('empresa' in referencia) {
            empresa = referencia.empresa;
        } else if ('estabelecimento' in referencia) {
            estabelecimento = referencia.estabelecimento;
        }

        this.refreshFilters(empresa, estabelecimento);

        if ('lotacao' in referencia) {
            this.filters.lotacao = referencia;
        } else if ('trabalhador' in referencia) {
            this.filters.trabalhador = referencia;
        }

        this.filterReload();
    }

    refreshFilters(empresa: string = '', estabelecimento: string = '') {
        this.filtersParams = { empresa, estabelecimento };

        const events = ['trabalhador_refresh', 'lotacao_refresh', 'departamento_refresh'];

        events.forEach(event =>
            this.$rootScope.$broadcast(event, this.filtersParams)
        );
    }

    filterReload(): void {
		this.busy = true;
		this.pagamentosLoaded = false;
		this.checkboxPreenchidos = [];
		this.displayEntities = [];

        if (!this.filters.apuracao) {
            this.entities = [];
            this.displayEntities = [];
			this.filterApuracoesStatusPagamento = null;
            this.busy = false;
            return;
		}

        const constructor = {
            apuracaoponto: this.filters.apuracao.apuracaoponto,
            empresa: this.$rootScope.session.entities.empresa.empresa,
            estabelecimento: ''
        };

        if (this.filters.trabalhador) {
			constructor['trabalhador'] = this.filters.trabalhador.trabalhador;
		}

		if (this.filters.lotacao) {
			constructor['trabalhador_lotacao'] = this.filters.lotacao.lotacao;
		}

        if (this.filters.departamento) {
			constructor['departamento'] = this.filters.departamento.departamento;
		}

        if (this.filters.grupo) {
			constructor['grupo'] = this.filters.grupo.grupo;
		}

		if (this.filters.situacaoColaborador) {
			constructor['trabalhador_status'] = this.filters.situacaoColaborador;
		}

		const filterApuracaoObj = this.apuracoes.filter(element => element.apuracaoponto === this.filters.apuracao!.apuracaoponto);
		this.filterApuracoesStatusPagamento = filterApuracaoObj[0]?.apuracaoprocessamento.statuspagamento;

		this.PagamentosPontoService.constructors = constructor;
		this.entities = this.PagamentosPontoService.reload();
    }

	loadMore(): void {
		this.PagamentosPontoService.loadMore();
	}

	liberarPagamentos(ano: string, mes: string): void {
		this.busy = true;
		this.PagamentosPontoService.liberarPagamentos(this.filters.apuracao!.apuracaoponto, ano, mes);
	}

	liberarPagamentosConfirm(): void {
        const diaFechamento = this.$rootScope.configuracoes['FECHAMENTO_FOLHA'] as string;
        const fechamentoProximoMes = this.$rootScope.configuracoes['FOLHA_FECHA_PROXIMO_MES'] as boolean;

        let dataReferencia = moment();
        if (fechamentoProximoMes) {
            dataReferencia = dataReferencia.clone().add(1, 'month');
        }

		const entity = {
			ano: dataReferencia.year(),
			mes: dataReferencia.month() + 1,
			diaFechamento,
			fechamentoProximoMes
		};
		const confirm = this.PagamentosPontoConfirmModalService.open(entity);

        confirm.result.then((result: IPagamentoConfirmModal) => {
			this.liberarPagamentos(result.ano.toString(), result.mes.toString());
        })
        .catch((error: any) => {
            if (error !== 'backdrop click' && error !== 'cancelar' && error !== 'escape key press') {
                this.NewToaster.pop({
                    type: 'error',
                    title: error
                });
            }
        });
	}

	regerarPagamentos(): void {
		this.busy = true;
		this.PagamentosPontoService.regerarPagamentos(this.filters.apuracao!.apuracaoponto);
	}

	regerarPagamentosConfirm(): void {
		let apuracaopontoDatas = this.apuracoesSelect.filter(element => element.apuracaoponto === this.filters.apuracao?.apuracaoponto);
        let textos = {
            title: 'Gerar novamente',
            subtitle: 'Caso alguma alteração tenha sido feita nos pontos dos colaboradores, ao gerar novamente os pagamentos as informações geradas anteriormente poderão ser alteradas.',
            confirmText: 'Você tem certeza que deseja gerar novamente os pagamentos da apuração de ' + apuracaopontoDatas[0].periodo,
            confirmTextNum: '',
            closeButton: 'Cancelar',
            confirmButton: 'Sim, gerar novamente',
        };
		let confirm = this.ModalConfirmService.open({}, 'Gerar novamente', false, textos);

        confirm.result.then((): void => {
            this.regerarPagamentos();
        })
        .catch((error: any): void => {
            if (error !== 'backdrop click' && error !== 'cancelar' && error !== 'escape key press') {
                this.NewToaster.pop({
                    type: 'error',
                    title: error
                });
            }
        });
	}

	regerarPagamentosIndividual(entity: IPagamentoPonto): void {
		this.busy = true;
		this.PagamentosPontoService.regerarPagamentosIndividual(this.filters.apuracao!.apuracaoponto, entity);
	}

	gerarNovamenteIndividualConfirm(entity: IPagamentoPonto): void {
        let textos = {
            title: 'Gerar novamente',
            subtitle: 'Caso alguma alteração tenha sido feita no ponto do colaborador, ao gerar novamente os pagamentos as informações geradas anteriormente poderão ser alteradas.',
            confirmText: 'Você tem certeza que deseja gerar novamente o pagamento do colaborador ' + entity.nome,
            confirmTextNum: '',
            closeButton: 'Cancelar',
            confirmButton: 'Sim, gerar novamente',
        };
		let confirm = this.ModalConfirmService.open({}, 'Gerar novamente', false, textos);

        confirm.result.then((): void => {
            this.regerarPagamentosIndividual(entity);
        })
        .catch((error: any): void => {
            if (error !== 'backdrop click' && error !== 'cancelar' && error !== 'escape key press') {
                this.NewToaster.pop({
                    type: 'error',
                    title: error
                });
            }
        });
	}

	exportar(): void {
		this.busy = true;
		let objetoExportacao = {
			'apuracaoponto': this.filters.apuracao?.apuracaoponto,
			'empresa': this.$rootScope.session.entities.empresa.empresa,
			'estabelecimento': this.$rootScope.session.entities.estabelecimento.estabelecimento,
			'trabalhadores' : [] as { 'trabalhador': string }[],
		};
		this.checkboxPreenchidos.forEach((element: IPagamentoPontoDisplayEntity) => {
			objetoExportacao.trabalhadores.push({'trabalhador': element.trabalhador});
		});
		this.PagamentosPontoService.exportar(objetoExportacao);
	}

	trataDownload(data: any): void {
		let nomeArquivo = '';
        var blob = new Blob([data]);
        let fileURL = (window.URL || window.webkitURL).createObjectURL(blob);
        var a = document.createElement('a');

		let apuracao = '';
		this.apuracoesSelect.forEach((element: any) => {
			if (apuracao === '' && element.apuracaoponto === this.filters.apuracao?.apuracaoponto) {
				apuracao = element.inicioapuracao + '-a-' + element.terminoapuracao;
			}
		});
		nomeArquivo = 'pagamentos-apuracao-' + apuracao + '.csv';

        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileURL;
        a.download = nomeArquivo;
        a.click();
        window.URL.revokeObjectURL(fileURL);
	}

	valorExiste(valor: any): boolean {
		return valor !== '' && valor !== undefined && valor !== null ? true : false;
	}

	private maybeBuildTable(): void {
		if (!this.rubricasLoaded) {
			return;
		}

		if (!this.fieldsBuilt) {
			this.montaFieldsTable();
		}

		if (!this.pagamentosLoaded) {
			return;
		}

		this.montaDisplayEntities();
		this.busy = false;
	}
}
